import orderPayments from "./orderPaymentsPT.json";
import orderTotal from "./orderTotal.json";

export const newOrderComponents = {
	orderPayments,
	orderTotal,
};
